/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Save_FailedInputs */

const en_toast_save_failed = /** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That change did not save, so it was undone.`)
};

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const ar_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const he_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const ur_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const es_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const fr_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const de_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const pt_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const hi_toast_save_failed = en_toast_save_failed;

/** @type {(inputs: Toast_Save_FailedInputs) => LocalizedString} */
const bn_toast_save_failed = en_toast_save_failed;

/**
* | output |
* | --- |
* | "That change did not save, so it was undone." |
*
* @param {Toast_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const toast_save_failed = /** @type {((inputs?: Toast_Save_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Save_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_toast_save_failed(inputs)
	if (locale === "he") return he_toast_save_failed(inputs)
	if (locale === "ur") return ur_toast_save_failed(inputs)
	if (locale === "es") return es_toast_save_failed(inputs)
	if (locale === "fr") return fr_toast_save_failed(inputs)
	if (locale === "de") return de_toast_save_failed(inputs)
	if (locale === "pt") return pt_toast_save_failed(inputs)
	if (locale === "hi") return hi_toast_save_failed(inputs)
	if (locale === "bn") return bn_toast_save_failed(inputs)
	return /** @type {LocalizedString} */ ("That change did not save, so it was undone.")
});